import { useDispatch } from "react-redux";
import { Button, Input } from "../../../../components/ui";
import useAddBeneficiary from "./useAddBeneficiary";
import { setAddBenefiSteps, setOpenBeneficiary } from "../bloc/beneficiariesSlice";
import TitleValueWidget from "../../../../components/trade_value_widget/TitleValueWidget";
import BenPayoutOtpVerification from "../ben-otp-verification";
import useBenficiaryOtpVerification from "../ben-otp-verification/useBenPayoutOtpVerication";
import CustomDropdown from "../../../../components/components-library/dropdown";

const AddBeneficiary = () => {
  const accType = [
    { label: "Savings", value: "Savings" },
    { label: "Current", value: "Current" },
  ];

  const traderType = [
    { label: "Vendor", value: "VENDOR" },
    { label: "Partner", value: "PARTNER" },
    { label: "Customer", value: "CUSTOMER" },
  ];

  const {
    addBenefi,
    setAddBenefi,
    onSubmit,
    otpScreen,
    setOtpScress,
    validateAddPayout,
    refId,
    addBenefiSteps
  } = useAddBeneficiary();
  const { sendOtpApiCall } = useBenficiaryOtpVerification({});

  const dispatch = useDispatch();

  return (
    <>
      <div className="card_space_18" style={{ height: "calc(-8rem + 100vh)" }}>
        {!otpScreen && addBenefiSteps === 1 ? (
          <div>
            <div className="grid grid-cols-3 w-full gap-4 space_18">
              <Input
                label="Account Holder"
                type="text"
                required={true}
                value={addBenefi?.accHolder}
                onChange={(e) => {
                  setAddBenefi({
                    ...addBenefi!,
                    accHolder: e.target.value,
                  });
                }}
                className="text-sm font-semibold"
              />

              <Input
                label="Account Number"
                type="Number"
                required={true}
                value={addBenefi?.accNumb}
                onChange={(e) => {
                  setAddBenefi({
                    ...addBenefi!,
                    accNumb: e.target.value,
                  });
                }}
                className="text-sm font-semibold"
              />

              <Input
                label="Bank Name"
                required={true}
                type="text"
                value={addBenefi?.bankName}
                onChange={(e) => {
                  setAddBenefi({
                    ...addBenefi!,
                    bankName: e.target.value,
                  });
                }}
                className="text-sm font-semibold"
              />
            </div>

            <div className="grid grid-cols-3 w-full gap-4 space_18">
              <Input
                label="IFSC Code"
                type="text"
                required={true}
                value={addBenefi?.ifscCode}
                onChange={(e) => {
                  setAddBenefi({
                    ...addBenefi!,
                    ifscCode: e.target.value.toUpperCase(),
                  });
                }}
                className="text-sm font-semibold"
              />

              <CustomDropdown
                label="Account Type"
                options={accType}
                required={true}
                value={addBenefi?.accountType}
                onChange={(value: any) => {
                  setAddBenefi({
                    ...addBenefi!,
                    accountType: value,
                  });
                }}
                placeholder=""
                className={""}
              // ulHeight={false}
              />

              <CustomDropdown
                label="Party Type"
                options={traderType}
                value={addBenefi?.traderType}
                onChange={(value: any) => {
                  setAddBenefi({
                    ...addBenefi!,
                    traderType: value,
                  });
                }}
                placeholder=""
                className={""} // ulHeight={false}
              />
            </div>

            <div className="grid grid-cols-3 w-full gap-4 space_18">
              <Input
                label="Contact Number"
                type="number"
                required={true}
                value={addBenefi?.mobile}
                onChange={(e) => {
                  const input = e.target.value;
                  const val = input.replace(/\D/g, "").slice(0, 10);
                  setAddBenefi({
                    ...addBenefi!,
                    mobile: val,
                  });
                }}
                className="text-sm font-semibold"
              />

              <Input
                label="Email Address"
                type="text"
                value={addBenefi?.email}
                onChange={(e) => {
                  setAddBenefi({
                    ...addBenefi!,
                    email: e.target.value,
                  });
                }}
                className="text-sm font-semibold"
              />
            </div>

            <div className="space_18">
              <Input
                label="Note 1"
                type="text"
                value={addBenefi?.note1}
                onChange={(e) => {
                  setAddBenefi({
                    ...addBenefi!,
                    note1: e.target.value,
                  });
                }}
                className="text-sm font-semibold"
              />
            </div>

            <div className="space_18">
              <Input
                label="Note 2"
                type="text"
                value={addBenefi?.note2}
                onChange={(e) => {
                  setAddBenefi({
                    ...addBenefi!,
                    note2: e.target.value,
                  });
                }}
                className="text-sm font-semibold"
              />
            </div>
          </div>
        ) : (
          <>
            <div className="bg-white rounded-lg card_space_18">
              <div className="grid grid-cols-3 w-full gap-4">
                <TitleValueWidget
                  title="Account Holder"
                  value={addBenefi?.accHolder}
                />

                <TitleValueWidget
                  title="Account Number"
                  value={addBenefi?.accNumb}
                />

                <TitleValueWidget
                  title="Bank Name"
                  value={addBenefi?.bankName}
                />
              </div>

              <div className="grid grid-cols-3 w-full gap-4 space_18">
                <TitleValueWidget
                  title="IFSC Code"
                  value={addBenefi?.ifscCode}
                />

                <TitleValueWidget
                  title="Account Type"
                  value={addBenefi?.accountType}
                />

                <TitleValueWidget
                  title="Party Type"
                  value={addBenefi?.traderType}
                />
              </div>

              <div className="grid grid-cols-3 w-full gap-4 space_18">
                <TitleValueWidget
                  title="Contact Number"
                  value={addBenefi?.mobile}
                />

                <TitleValueWidget
                  title="Email Address"
                  value={addBenefi?.email}
                />
              </div>

              <div className="space_18">
                <TitleValueWidget title="Note 1" value={addBenefi?.note1} />
              </div>

              <div className="space_18">
                <TitleValueWidget title="Note 2" value={addBenefi?.note2} />
              </div>
            </div>
            <div>
              <BenPayoutOtpVerification type="BENF" />
            </div>
          </>
        )}
      </div>

      <div className="bg-white flex absolute bottom-0 justify-between items-center gap-10 px-6 py-4 w-full border-t">


        {addBenefiSteps === 1 && (
          <>
            <Button
              className="w-[100px]"
              onClick={() => {
                dispatch(setOpenBeneficiary(false));
              }}
              variant="transparent"
            >
              Cancel
            </Button>

            <Button
              className="w-[100px]"
              onClick={() => {
                if (!otpScreen) {
                  if (validateAddPayout()) {
                    sendOtpApiCall("TP_BEN");
                    setOtpScress(true);
                    dispatch(setAddBenefiSteps(2));
                  }
                }
              }}
              variant="contained"
              disabled={!refId && otpScreen}
            >
              Next
            </Button>
          </>
        )}

        {addBenefiSteps === 2 && (
          <>
            <Button
              className="w-[100px]"
              onClick={() => {
                dispatch(setAddBenefiSteps(1));
                setOtpScress(false); 
              }}
              variant="transparent"
            >
              Previous
            </Button>

            <Button
              className="w-[100px]"
              onClick={() => {
                onSubmit();
              }}
              variant="contained"
              disabled={!refId && otpScreen}
            >
              Submit
            </Button>
          </>
        )}
      </div>
    </>
  );
};
export default AddBeneficiary;
